module.exports = __webpack_public_path__ + "img/logo-empty.c8c7f66b.png";